var seedrandom = require('seedrandom');
var self = require('./shuffle-seed');

module.exports = self;




//////////////////
// WEBPACK FOOTER
// ./node_modules/shuffle-seed/index.js
// module id = ./node_modules/shuffle-seed/index.js
// module chunks = 0